const getArrayYears = () => {
  const start = new Date().getFullYear()
  const stop = 1970
  const step = -1
  const range = Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step))
  return range.reduce((acc, el) => [...acc, { id: el, name: el.toString() }], [])
}

export default getArrayYears
